import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';

export function PhoneButton({ desktopAction }: { desktopAction: () => void }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIsMobile = () => {
            if (/android|iphone|ipad|ipod|opera mini|iemobile|wpdesktop/i.test(navigator.userAgent.toLowerCase())) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        checkIsMobile();
    }, []);

    const handleClick = (e: { preventDefault: () => void; }) => {
        if (!isMobile) {
            e.preventDefault(); // prevent default link behavior on desktop
            if (typeof desktopAction === 'function') {
                desktopAction();
            }
        }
        // on mobile, it will proceed with tel: link
    };

    return (
        <a
            href={isMobile ? 'tel:9784434411' : '#'}
            onClick={handleClick}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '12px 20px',
                borderRadius: '9999px', // fully rounded
                backgroundColor: 'black',
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                gap: '8px'
            }}
        >
            <Phone size={20} />
            Give us a call
        </a>
    );
}